import React, { useEffect } from 'react';
import AllRoute from '../router'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const App = () => {

  useEffect(() => {
    const handleStorageChange = (event) => {
      // If the auth_token is changed or removed in another tab
      if (event.key === 'auth_token') {
        console.log('Authentication token changed in another tab. Reloading...');
        // Instead of reloading (which uses the new token to fetch data on the current page),
        // we forcefully redirect the background tab to the login screen so it doesn't 
        // show incorrect data or mix sessions.
        window.location.href = '/sign_in';
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  return (
    <div className="App" id='scrool'>
      <AllRoute />
      <ToastContainer />
    </div>
  );
}

export default App;